const state = {
    push: [],
    pushId: [],
    loading: false
};

export default state;